import type { CSSProperties } from "react";

interface ModalStyles {
  mask: CSSProperties;
  content: CSSProperties;
  body: CSSProperties;
}

export const modalStyles: ModalStyles = {
  mask: {
    backdropFilter: "blur(4px)",
  },
  content: {
    padding: 0,
    borderRadius: 12,
    overflow: "hidden",
    boxShadow: "0 24px 80px rgba(15, 23, 42, 0.18)",
  },
  body: {
    padding: 0,
  },
};

export const modalWrapStyle: CSSProperties = {
  maxWidth: "calc(100vw - 32px)",
};
